// SKILL:MANAGED
import React, {
  createContext,
  useEffect,
  useState,
  useRef,
} from 'react';
import { bridge } from '@web/src/lib/nativeBridge';

interface BridgeContextValue {
  isNative: boolean;
  bridge: typeof bridge;
}

export const BridgeContext = createContext<BridgeContextValue | null>(null);

interface Props {
  children: React.ReactNode;
  onForeground?: () => void;
}

export function BridgeProvider({ children, onForeground }: Props) {
  const [isNative] = useState(() => {
    if (typeof window === 'undefined') return false;
    return !!window.__NativeBridge?.isNative;
  });

  const onForegroundRef = useRef(onForeground);
  useEffect(() => {
    onForegroundRef.current = onForeground;
  });

  useEffect(() => {
    if (!isNative) return;

    const unsubscribe = bridge.on('native:foreground', () => {
      onForegroundRef.current?.();
    });

    return unsubscribe;
  }, [isNative]);

  return (
    <BridgeContext.Provider value={{ isNative, bridge }}>
      {children}
    </BridgeContext.Provider>
  );
}
